<template>
  <zj-layout-container>
    <zj-layout-main style="padding:0rem 0rem;">
      <div class="zj-layout-main-content scrollable" style="padding:0rem 0rem;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="editable">
          <el-checkbox-group
            @change="handleCheckedChange"
            v-model="Usersids"
            class="zj-user-list"
          >
            <el-checkbox
              v-for="item in UsersOptions"
              :key="item.id"
              :label="item.id"
              :value="item.id"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form>
      </div>
    </zj-layout-main>
    
  </zj-layout-container>
</template>
<script>
import { list } from "@/api/src/emergency_person";

export default {
  name: "ZjUserListControl",
  controller: "UI",
  action: "UserListControl",
  components: {},
  props: {
    ResourceTypeId: { type: String },
    PersonOrgianiztionId: { type: String },
    form:{ type: Object }
  },
  data() {
    return {
      UsersOptions: [],
      Usersids: [],
      CheckedUserItems: [],
    };
  },
  created: function () {
    if (this.ResourceTypeId != "" && this.PersonOrgianiztionId != "") {
      this.GetUserData();
    }
  },
  methods: {
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    GetUserData() {
      this.showLoading('加载中...');
      list({
          ResourceTypeId: this.ResourceTypeId,
          belongDeptId: this.PersonOrgianiztionId,
          current:1,
          size:2000
        })
        .then((r) => {
          var data = r.data.records;
          if (data) {
            data.forEach(a =>{
              a.isSubmit = false
              a.obj = {}
            })
            this.UsersOptions = data;
          }
          this.hideLoading();
        })
        .catch((e) => {
          console.error(e);
          this.hideLoading();
        });
    },
    handleCheckedChange(value) {
      let that = this, { form } = that
      this.Usersids = value;

      this.CheckedUserItems = this.UsersOptions.filter((item) => {
        return that.Usersids.includes(item.id);
      }).map((item) => {
        return item.isSubmit ? item.obj : {
          personId: item.id,
          organizationId: item.belongDeptId	,
          organizationType: item.belongDeptType,
        };
      });
    },
    setDefaultCheckItems() {
      let that = this, { form, UsersOptions } = that,InputUsersids=[]
      if(form.hasOwnProperty('sms') && form.sms.personList.length){
        InputUsersids = form.sms.personList
      }
      if (
        InputUsersids &&
        InputUsersids.length > 0 &&
        UsersOptions &&
        UsersOptions.length > 0
      ) {
        InputUsersids.forEach((item) => {
          // if (
          //   that.UsersOptions.some((a) => {
          //     return a.id == item.personId;
          //   })
          // ) {
          //   that.Usersids.push(item.personId);
          //   that.CheckedUserItems.push(item)
          // }
          UsersOptions.some((a) => {
            if(a.id == item.personId){
                that.Usersids.push(item.personId);
                that.CheckedUserItems.push(item)
                a.isSubmit = true
                a.obj = item
             }
          })
        });
      }
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    'form.sms':{
       handler(val, oldVal) {
        if (val) {
          console.log(val,'tongxin')
          this.setDefaultCheckItems();
        }
      },
      deep: true,
      immediate: true,
    },
    UsersOptions: function () {
      this.setDefaultCheckItems();
    },
  },
};
</script>